// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1WfBe","title":"Images45_title__tJjeS","images":"Images45_images__2sQ4Q"};